import React from 'react';

import { FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';
import { USER } from '../../../data/reducer';
import { doUpdateHpaInfoNotification } from '../data/actions';

import Notification from '../../../components/Notification';
import OTIcon from '../../../components/tag/OTIcon';
import OTButton from '../../../components/tag/OTButton';

const { id: module_id } = module;

const HpaInfoNotification = (props) => {
  const { updateHpaInfoNotification, userInfo } = props;

  return (
    <Notification>
      <FormattedMessage
        id={`${module_id}.update.contact.info.header`}
        values={{ name: userInfo.wholeName }}
      >
        {(txt) => (
          <h2>
            <OTIcon
              className="ot-notification__icon icon-user"
              config={{ type: 'fa', name: 'icon-user' }}
            />
            <span className="ot-notification__header">{txt}</span>
          </h2>
        )}
      </FormattedMessage>

      <div className="ot-notification__description">
        <FormattedMessage
          id={`${module_id}.update.contact.info.body`}
          values={{ name: userInfo.wholeName }}
          tagName="p"
        />
      </div>

      <OTButton
        onClick={updateHpaInfoNotification}
        className="ot-notification__button"
      >
        <FormattedMessage id={'OK'} />
      </OTButton>
    </Notification>
  );
};

const mapDispatchToProps = (dispatch) => {
  return {
    updateHpaInfoNotification: () => dispatch(doUpdateHpaInfoNotification()),
  };
};

const mapStateToProps = (state) => {
  return {
    userInfo: state[USER].userInfo.data,
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(HpaInfoNotification);
